import { VStack } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { ContentTrackList } from '@src/components/sco/Education/ContentTrackLanding/ContentTrackList';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { EducationPage } from '@src/templates/EducationPage';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  useUniversalEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
    });
    educationContext.setBreadcrumbs([{
      title: 'Courses',
      href: '/courses'
    }]);
    educationContext.setActiveSection('courses.landing');
    educationContext.setActiveContentItem(null);
  }, []);
  return <VStack align={'center'} gap={0} justify={'stretch'} width={'full'}>
      <VStack align={'center'} padding={getBreakpointValue([4, 4, 6, 10])} width={'full'}>
        <VStack align={'flex-start'} gap={10} maxWidth={'container.xl'} width={'full'}>
          <ContentTrackList />
        </VStack>
      </VStack>
    </VStack>;
});